import React from "react";
import { DirectionalHint, TooltipHost } from '@fluentui/react';
import { CommandBarButton, IconButton } from '@fluentui/react/lib/Button';
import { OverflowSet } from '@fluentui/react/lib/OverflowSet';

const iconButtonStyles = { root: { float: 'right', height: 'inherit', padding: '10px' } };
const onRenderItemStyles = { root: { padding: '10px' } };
const onRenderOverflowButtonStyles = { root: { padding: '10px' }, menuIcon: { fontSize: '16px' } };

const columnRender_Name = (item, history, listUserPageText) => {
    return  <div>
                {item.name}
                <IconButton
                    type="button"
                    menuIconProps={{ iconName: 'MoreVertical' }}
                    role="button"
                    className="action-menu-list-toolbar"
                    aria-haspopup
                    styles={iconButtonStyles}
                    menuProps={{
                        items: [
                            {
                                key: 'listusers',
                                iconProps: { iconName: 'PageListSolid' },
                                text: listUserPageText,
                                className: "ms-Icon-custom",
                                onClick: () => handleOptionClick(item, "/listusers", history),
                            },
                        ],
                    }}
                />
            </div>
};

const ColumnRender_Actions = (item, onlyObserver, history, l_pageTexts) => {
    return  <div>
        <OverflowSet
            className="action-menu-list-toolbar d-flex justify-content-center"
            role="menubar"      
            items={[
                {
                    key: 'navigate',
                    icon: 'NavigateBackMirrored',
                    name: l_pageTexts.profile,
                    title: l_pageTexts.profile,
                    onClick: () => handleOptionClick(item, "/profileclient", history),
                },
                {
                    key: 'edit',
                    icon: 'WindowEdit',
                    name: l_pageTexts.edituser,
                    title: l_pageTexts.edituser,
                    onClick: () => handleOptionClick(item, "/editclient", history),
                },
                {
                    key: 'manage',
                    icon: 'ShoppingCart',
                    name: l_pageTexts.manageproducts,
                    title: l_pageTexts.manageproducts,
                    onClick: () => handleOptionClick(item, "/manageproducts", history),
                },
            ].filter(x => onlyObserver !== true)}
            onRenderOverflowButton={onRenderOverflowButton}
            onRenderItem={onRenderItem}
        />
    </div>
};

const handleOptionClick = (item, url, history) => {
    history.push(url, { clientId: item.id })
}

const onRenderOverflowButton = (overflowItems) => {
    return (
      <TooltipHost content="More items" directionalHint={DirectionalHint.rightCenter}>
        <CommandBarButton
          role="menuitem"
          aria-label="More items"
          styles={onRenderOverflowButtonStyles}
          menuIconProps={{ iconName: 'More' }}
          menuProps={{ items: overflowItems }}
        />
      </TooltipHost>
    );
};

const onRenderItem = (item) => {
    return (
      <TooltipHost content={item.title} directionalHint={DirectionalHint.rightCenter}>
        <CommandBarButton
          role="menuitem"
          aria-label={item.name}
          styles={onRenderItemStyles}
          iconProps={{ iconName: item.icon }}
          onClick={item.onClick}
        />
      </TooltipHost>
    );
};

export {
    columnRender_Name,
    ColumnRender_Actions,
}
